
var sprite = require("D:/a/1/s/Web/CMS/App_Themes/Safestore/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 17 15.001\" id=\"icon-user\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <path d=\"M8.5,0C3.806,0,0,3.723,0,8.313c0,2.736,1.352,5.163,3.438,6.679c0.388-2.212,2.558-3.783,5.053-3.783\r\n\tc2.51,0,4.689,1.482,5.059,3.792C15.643,13.487,17,11.056,17,8.313C17,3.723,13.194,0,8.5,0z M8.49,10.222\r\n\tc-1.738,0-3.148-1.979-3.148-4.382c0-1.701,1.41-3.079,3.148-3.079s3.147,1.378,3.147,3.079C11.638,8.372,10.229,10.222,8.49,10.222\r\n\tz\"/> </symbol>";
module.exports = sprite.add(image, "icon-user");


/*****************
 ** WEBPACK FOOTER
 ** ./svg/src/user.svg
 ** module id = 239
 ** module chunks = 24
 **/